export const compareNumbers = (a: number, b: number) => a - b

/**
 * Get the browser timezone
 * @returns IANA's format broswer timezone
 */
/* istanbul ignore next since it is only a native function wrapper*/
export const getBrowserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone
